import { Box, Button, Container, Flex, HStack, Image, Link } from '@chakra-ui/react';
import React from 'react';

export const Header: React.FC = () => {
  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={1000}
      bg="rgba(255, 255, 255, 0.7)"
      backdropFilter="blur(12px)"
      borderBottom="1px solid"
      borderColor="gray.200"
      boxShadow="sm"
    >
      <Container maxW="container.xl">
        <Flex h={16} alignItems="center" justifyContent="space-between">
          <Flex width="88px" align="center" gap="10px">
            <Image src="/assets/logo.png" width="100%" fontWeight="bold" />
          </Flex>

          <HStack display={{ base: 'none', md: 'flex' }}>
            <Link
              href="#features"
              fontSize="sm"
              color="gray.600"
              _hover={{ color: 'green.500' }}
              transition="color 0.2s"
              scrollMarginTop="80px"
            >
              Üstünlüklər
            </Link>
            <Link
              href="#platforms"
              fontSize="sm"
              color="gray.600"
              _hover={{ color: 'green.500' }}
              transition="color 0.2s"
            >
              Platformalar
            </Link>
            <Link
              href="#contact"
              fontSize="sm"
              color="gray.600"
              _hover={{ color: 'green.500' }}
              transition="color 0.2s"
            >
              Əlaqə
            </Link>
          </HStack>

          <Button
            bg="#2DAC5C"
            size="md"
            px={6}
            borderRadius="10px"
            onClick={() => {
              const phone = '994773292228'; // + işarəsi olmadan
              const message = encodeURIComponent(
                'Salam, CaspiPos haqqında məlumat almaq istəyirəm'
              );

              window.location.href = `https://wa.me/${phone}?text=${message}`;
            }}
          >
            İndi Alın
          </Button>
        </Flex>
      </Container>
    </Box>
  );
};
